import { Component, OnInit } from '@angular/core';
import { SignupService } from 'src/app/services/signup.service';
import { WatcherService } from 'src/app/services/watcher.service';
@Component({
    selector: 'app-us-to-de-component',
    templateUrl: './us-to-de.component.html',
    styleUrls: ['./us-to-de.component.css']
})
export class UsToDeComponent implements OnInit {

    constructor(
        public signUpService: SignupService,
        private watcherService: WatcherService
    ) { }

    lang;
    ngOnInit(): void {
        this.watcherService.getLang().subscribe(
            lang => {
                this.lang = lang;
            }
        )
        
        this.signUpService.updateWebsiteTitle("Shippn - Your Partner for Easy Shipping from U.S.A. to Germany");
        this.signUpService.updateWebsiteDescription("This page explains how to  Shop online from the U.S.A. through Shippn hosts that live in U.S.A. and get your purchase delivered to your doorstep. ")
    }
}
